import { API_BASE } from "./api";

export async function streamAI(path, body, onText) {
  const res = await fetch(`${API_BASE}${path}`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body || {}),
  });
  if (!res.ok || !res.body) {
    let msg = "The AI writer is unavailable right now. Please try again.";
    try { msg = (await res.json())?.detail || msg; } catch { /* ignore */ }
    throw new Error(typeof msg === "string" ? msg : "Please check the form and try again.");
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let text = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const events = buffer.split("\n\n");
    buffer = events.pop();
    for (const ev of events) {
      const data = ev.replace(/^data: /, "").trim();
      if (!data || data === "[DONE]") continue;
      const parsed = JSON.parse(data);
      if (parsed.error) throw new Error(parsed.error);
      text += parsed.t || "";
      onText(text);
    }
  }
  return text;
}

export function parseFields(text, keys) {
  const out = {};
  keys.forEach((k, i) => {
    const next = keys[i + 1];
    const re = new RegExp(`${k}:\\s*([\\s\\S]*?)${next ? `(?=\\n?${next}:|$)` : "$"}`);
    const m = text.match(re);
    if (m) out[k] = m[1].trim();
  });
  return out;
}
